import { RoomState } from './index';
// @ts-ignore
import { IState } from '../index';
import { GetterTree } from 'vuex';
import AvailableRoom from "../interfaces/availableRoom";
import Room from "../interfaces/room";
import CheckoutItem from "../interfaces/checkoutItem";

export default {
    infants(state): boolean {
        return state.availableRooms[0] !== undefined ? state.availableRooms[0].infants : false;
    },
    children(state): boolean {
        return state.availableRooms[0] !== undefined ? state.availableRooms[0].children : false;
    },
    teenager(state): boolean {
        return state.availableRooms[0] !== undefined ? state.availableRooms[0].teenager : false;
    },
    doubleRoomId(state): string | undefined {
        const dr: AvailableRoom | undefined = state.availableRooms.find((room: AvailableRoom) => room.roomType === 'dr');

        if (dr === undefined) {
            return;
        }

        return dr.id
    },
    singleRoomId(state): string | undefined {
        const sr: AvailableRoom | undefined = state.availableRooms.find((room: AvailableRoom) => room.roomType === 'sr');

        if (sr === undefined) {
            return;
        }

        return sr.id;
    },
    roomAmountById: (state) => (id: string) => {
        const room = state.rooms.find((room: CheckoutItem) => room.id === id);
        return room !== undefined ? room.amount : 0;
    },
    travellersLeft(state, _, rootState): number {
        let travellersLeft: number = rootState.checkout.checkoutSummary.travellerCount.adults;

        state.rooms.forEach((room: Room) => {
            travellersLeft -= room.amount * room.minPersons;
        })

        return travellersLeft;
    },
    maxRoomAddAmount: (state, getters) => (id: string) => {
        const room = state.availableRooms.find((room: AvailableRoom) => room.id === id);

        if (room === undefined) {
            return 0;
        }

        const travellersLeft: number = getters.travellersLeft;

        return Math.floor(travellersLeft / room.minPersons);
    },
    getRooms(state): Room[] {
        return state.rooms;
    },
    doubleRoomAutoFill(state, _, rootState): number {
        return Math.floor(rootState.checkout.checkoutSummary.travellerCount.adults / 2)
    },
    singleRoomAutoFill(state, _, rootState): number {
        return rootState.checkout.checkoutSummary.travellerCount.adults % 2;
    },
    getSelectedRooms(state): Room[] {
        return state.rooms.filter((room: Room) => room.amount > 0);
    }
} as GetterTree<RoomState, IState>
